import { QueryClient } from "@tanstack/react-query";
import { Stage } from "../lusca-search-api/generated-src";

export interface FallbackResponse {
  originalId?: string;
  resolvedId?: string;
  type?: string;
}

interface DetailsWithFallback {
  events: unknown[];
  cbes: unknown[];
  auids?: string[];
  fallback?: FallbackResponse;
}

export const getDetailsQueryKey = (stage: Stage, orderId: string) =>
  ["details", stage, orderId] as const;

export const getSiblingsQueryKey = (
  stage: Stage,
  digitalOrderId: string | undefined
) => ["siblings", stage, digitalOrderId] as const;

export const cacheFallbackDetails = (
  queryClient: QueryClient,
  stage: Stage,
  details: DetailsWithFallback
) => {
  if (!details.fallback) return;

  const { originalId, resolvedId, type } = details.fallback;
  if (!originalId || !resolvedId) return;

  queryClient.setQueryData(getDetailsQueryKey(stage, resolvedId), {
    events: details.events,
    cbes: details.cbes,
    auids: details.auids,
    cachedFromFallback: true,
  });

  if (type !== "subscriptionId") {
    queryClient.setQueryData(getSiblingsQueryKey(stage, originalId), []);
  }
};
